export const localization = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Uso do Plano',
      description:
        'Acompanhe os principais indicadores de desempenho da sua operação conversacional. Essa visão reúne dados do portal Blip, permitindo entender o volume de DAUs.',
      learnMore: 'Saiba mais sobre os termos.',
      modalContent: {
        title: 'Detalhamento dos Termos',
        description: '<strong>DAU (Daily Active User)</strong>: Usuário Ativo Diário único por chatbot principal (router). Será contabilizado todo usuário que, dentro de um mesmo dia (das 00h00 às 23h59, horário de Brasília), recebeu ou enviou qualquer tipo de mensagem (como texto, imagem, documento, vídeo, clique e quick reply). Para que não haja dúvidas, os DAUs serão contabilizados por usuário distinto e por chatbot. Assim, se houver troca de mensagens com dois chatbots da empresa em um mesmo dia, serão cobrados dois DAUs.',
        action: 'Entendido',
      },
      showMoreButton: 'Ver mais',
    },
    leftChart: {
      title: 'Consumo do plano contratado',
      labels: { counted: '{0} Conversas Únicas consumidas', available: '{0} Conversas Únicas disponíveis' },
      customLabels: { counted: '{0}%: Conversas Únicas consumidas', available: '{0}%: Conversas Únicas disponíveis' },
    },
    leftInfoPaper: {
      totalInfo: {
        description: 'Total de Conversas Únicas consumido nesse mês',
      },
      availableInfo: {
        description: 'Conversas Únicas restantes disponíveis no plano',
      },
      planInfo: {
        description: 'Total de Conversas Únicas do plano contratado',
        tooltip: 'Número de Conversas Únicas disponíveis por mês no plano contratado',
      },
    },
    rightChart: {
      period: '{startDate} a {endDate}',
      title: 'Consumo semanal de DAU',
      customLabel: 'DAUs consumidos',
      warningLabel: {
        bold: 'Importante: ',
        regular:
          'usuários que receberem uma notificação ativa, mesmo que não a respondam, serão contabilizados. Várias mensagens podem ser trocadas com um mesmo usuário ativo, entre o período mencionado, contabilizando uma única conversa.',
      },
    },
    rightInfoPaper: {
      totalMiu: {
        description: 'Volume de DAUs do mês atual',
        tooltipText: 'DAU (Daily Active User): Usuário Ativo Diário',
      },
      weeklyAverage: {
        description: 'Média semanal de consumo de DAUs',
      },
      topWeekNumber: {
        label: '{0} semana',
        description: 'Foi a semana com maior consumo de DAUs do mês selecionado',
      },
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'Plan Usage',
      description:
        'Track your conversational operation\'s key performance indicators. This view gathers data from the Blip portal, helping you understand the volume of DAUs.',
      learnMore: 'Learn more about the terms',
      modalContent: {
        title: 'Detailed explanation of terms',
        description: '<strong>DAU (Daily Active User)</strong>: Unique daily active user per main chatbot (router). Any user who, within the same day (from 00:00 to 23:59 Brasília time), sent or received any type of message (such as text, image, document, video, click, or quick reply) will be counted. To avoid doubts, DAUs are counted per single (unique) user and per chatbot. Therefore, if a user interacts with two different company chatbots on the same day, they will be counted as two DAUs.',
        action: 'Close',
      },
      showMoreButton: 'See more',
    },
    leftChart: {
      title: 'Plan usage',
      labels: { counted: '{0} Single Conversations Consumption', available: '{0} Single Conversations Available' },
      customLabels: { counted: '{0}%: Single Conversations Consumption', available: '{0}%: Single Conversations Available' },
    },
    leftInfoPaper: {
      totalInfo: {
        description: 'Total of Single Conversations consumed this month',
      },
      availableInfo: {
        description: 'Remaining Single Conversations available in the plan',
      },
      planInfo: {
        description: 'Total of Single Conversations in your plan',
        tooltip: 'Number of Single Conversations available per month on your plan',
      },
    },
    rightChart: {
      period: '{startDate} to {endDate}',
      title: 'Weekly consumption of DAUs',
      customLabel: 'Used DAUs',
      warningLabel: {
        bold: 'Attention: ',
        regular:
          'every user that receives a proactive notification will be counted, even if they do not reply. Within the given period, multiple messages can be exchanged with the same active user, which counts as a single conversation.',
      },
    },
    rightInfoPaper: {
      totalMiu: {
        description: 'Current month\'s DAUs volume',
        tooltipText: 'DAU (Daily Active User)',
      },
      weeklyAverage: {
        description: 'Average weekly consumption of DAUs',
      },
      topWeekNumber: {
        label: '{0} week',
        description: 'Week with the highest consumption of DAUs for the selected month',
      },
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Uso del Plan',
      description:
        'Sigue los principales indicadores de rendimiento de tu operación conversacional. Esta vista reúne datos del portal Blip y te permite entender el volumen de DAUs.',
      learnMore: 'Obtén más información sobre estos términos',
      modalContent: {
        title: 'Detailed explanation of terms',
        description: '<strong>DAU (Daily Active User)</strong>: Usuario activo diario único por chatbot principal (router). Se contabilizará todo usuario que, dentro de un mismo día (de 00:00 a 23:59, horario de Brasília), haya enviado o recibido cualquier tipo de mensaje (como texto, imagen, documento, video, clic o respuesta rápida). Para mayor claridad, los DAUs se contabilizan por usuario distinto y por chatbot. Por lo tanto, si un usuario interactúa con dos chatbots diferentes de la empresa en el mismo día, se contabilizarán dos DAU.',
        action: 'Close',
      },
      showMoreButton: 'Ver más',
    },
    leftChart: {
      title: 'Consumo del plan contratado',
      labels: { counted: '{0} Conversaciones Únicas consumidas', available: '{0} Conversaciones Únicas disponibles' },
      customLabels: { counted: '{0}%: Conversaciones Únicas consumidas', available: '{0}%: Conversaciones Únicas disponibles' },
    },
    leftInfoPaper: {
      totalInfo: {
        description: 'Total de Conversaciones Únicas consumidas este mes',
      },
      availableInfo: {
        description: 'Conversaciones Únicas restantes disponibles en el plan',
      },
      planInfo: {
        description: 'Total de Conversaciones Únicas en su plan',
        tooltip: 'Numero de Conversaciones Únicas disponibles por mes en el plan contratado',
      },
    },
    rightChart: {
      period: '{startDate} al {endDate}',
      title: 'Consumo semanal de Conversaciones Únicas',
      customLabel: 'DAUs consumidos',
      warningLabel: {
        bold: 'Importante: ',
        regular: 'los usuarios que reciban una notificación proactiva, aunque no la contesten, serán contabilizados. Se pueden intercambiar varios mensajes con el mismo usuario activo, entre el periodo mencionado, contando como una única conversación.',
      },
    },
    rightInfoPaper: {
      totalMiu: {
        description: 'Volumen de DAUs del mes actual',
        tooltipText: 'DAU (Daily Active User): Usuario Activo Diario',
      },
      weeklyAverage: {
        description: 'Consumo promedio semanal de DAUs',
      },
      topWeekNumber: {
        label: '{0} semana',
        description: 'Semana con mayor consumo de DAUs para el mes seleccionado',
      },
    },
  },
};
